import { asyncActionType } from "utils/constants";

export const GET_ALERTS_BY_LOCATION = asyncActionType("GET_ALERTS_BY_LOCATION");
export const DEACTIVATE_ALERTS_BY_LOCATION = asyncActionType("DEACTIVATE_ALERTS_BY_LOCATION");
export const GET_NOT_VIEWED_ALERTS_TOTAL = asyncActionType("GET_NOT_VIEWED_ALERTS_TOTAL");
